export function isCodAvailable(store, delivery, pincode, serviceability) {
  return Boolean(
    store?.codEnabled
    && delivery === "COURIER"
    && /^\d{6}$/.test(pincode)
    && String(serviceability?.pincode || "").trim() === String(pincode).trim()
    && serviceability?.serviceable === true
    && serviceability?.codServiceable === true
  );
}
